define.alias("@embroider/util/services/ensure-registered", "settings/services/-ensure-registered");